import { fetchCachedHelper, fetchHelper } from '../../api/api'
import { blogActions } from './blogSlice'
import { blogViewActions } from './blogViewSlice'
import { getNormalizedAuthors } from '../../util/functions'

const getPosts = params => async dispatch => {
    dispatch(blogActions.getPostsRequest())
    try {
        const response = await fetchCachedHelper('Blogpost', {
            params,
        })
        const { data: posts, paging } = response.data

        const authors = await getPostAuthors(posts)

        posts.forEach(post => {
            post.author = authors.entities.authors[post.author]
        })

        dispatch(blogActions.getPostsRequestSuccess({ posts, paging }))
    } catch (e) {
        dispatch(blogActions.getPostsRequestFailure(e.message))
    }
}

const getPost = postId => async dispatch => {
    dispatch(blogViewActions.getPostsRequest())
    try {
        const [postResponse, postThumbnailResponse] = await Promise.all([
            fetchCachedHelper(`Blogpost/${postId}`),
            fetchCachedHelper(`Blogpost/GetThumbnail/${postId}`),
        ])

        let post = {
            ...postResponse.data,
            thumbnail: postThumbnailResponse.data,
        }

        post.author = await getAuthor(post.author)

        dispatch(blogViewActions.getPostsRequestSuccess({ post }))
    } catch (e) {
        dispatch(blogViewActions.getPostsRequestFailure(e.message))
    }
}

export const getRelatedPosts = postId => async dispatch => {
    dispatch(blogViewActions.getRelatedPostsRequest())
    try {
        const relatedPostsRes = await fetchHelper(
            `Blogpost/GetRelatedPosts/${postId}`
        )

        const relatedPosts = relatedPostsRes.data

        const [authors, thumbnailsRes] = await Promise.all([
            getPostAuthors(relatedPosts),
            Promise.all(
                relatedPosts.map(({ postid }) =>
                    fetchCachedHelper(`Blogpost/GetThumbnail/${postid}`)
                )
            ),
        ])

        relatedPosts.forEach((post, idx) => {
            post.author = authors.entities.authors[post.author]
            post.thumbnail = thumbnailsRes[idx].data
        })

        dispatch(
            blogViewActions.getRelatedPostsRequestSuccess({
                posts: relatedPosts,
            })
        )
    } catch (e) {
        dispatch(
            blogViewActions.getRelatedPostsRequestFailure({ error: e.message })
        )
    }
}

export const increasePostView = id => dispatch =>
    fetchHelper.post(`Blogpost/IncreaseViews/${id}`)

const getAuthor = async email => {
    const [userResponse, dpResponse] = await Promise.all([
        fetchCachedHelper(`Users/${email}`),
        fetchCachedHelper(`Users/GetDp/${email}`).catch(err => {
            //The API returns a 404 error if it can't find the user's dp
            if (!(err.response && err.response.status === 404)) {
                throw new Error('Something went wrong')
            }
        }),
    ])

    let user = userResponse.data

    user = {
        ...user,
        dp: dpResponse ? dpResponse.data : '',
    }

    return user
}

export const getPostAuthors = async posts => {
    const authorMails = [...new Set(posts.map(({ author }) => author))]
    const authors = await Promise.all(authorMails.map(mail => getAuthor(mail)))

    return getNormalizedAuthors(authors)
}

export const blogApi = {
    getPosts,
    getPost,
    getRelatedPosts,
}
